import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  type OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { News } from 'src/app/core/models/news';

@Component({
  selector: 'card-news',
  templateUrl: './card-news.component.html',
  styleUrls: ['./card-news.component.scss'],
})
export class CardNewsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() news: Partial<News> | undefined;
  @Input() showNoImage: boolean = false;
  @Input() isDark: boolean = false;
  @Input() isPreview: boolean = false;
  @Input() forceVertical: boolean = false;
  @Input() isSearchResult: boolean = false;

  @Output() clickNews = new EventEmitter<News>();
  @ViewChild('newsContainer') newsElement: ElementRef | undefined;

  translatedMetadata:
    | {
        title?: string;
        category?: string;
        plain_content?: string;
        bullets?: string;
        picture?: string;
      }
    | undefined;
  translatedContent: string | undefined;
  currentLocale: string = 'en-GB';

  private langChangeSubscription: Subscription | undefined;

  constructor(
    private el: ElementRef,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.applyTranslation(this.translateService.currentLang);
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event) => {
        this.applyTranslation(event.lang);
      }
    );
  }

  ngOnDestroy(): void {
    this.langChangeSubscription?.unsubscribe();
  }

  private applyTranslation(lang: string): void {
    this.currentLocale = lang === 'pt' ? 'pt-BR' : 'en-GB';

    if (!this.news?.translations) {
      this.translatedMetadata = undefined;
      this.translatedContent = undefined;
      return;
    }

    const translation = this.news.translations[lang as 'pt' | 'en'];
    this.translatedMetadata = translation?.metadata;
    this.translatedContent = translation?.content;
  }

  ngAfterViewInit(): void {
    console.log('check 2', this.checkConditionStyle());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.log('check resize', this.checkConditionStyle());
  }

  getFirstSentence(content: string) {
    if (!content) return '';

    const sentences = content.split('.');
    return sentences[0];
  }

  readMore(news: any) {
    this.clickNews.emit(news);
  }

  checkConditionStyle() {
    if (!this.newsElement) return;
    const width = this.newsElement.nativeElement.offsetWidth;

    if (width < 500) {
      this.newsElement.nativeElement.classList.add('vertical');
      this.newsElement.nativeElement.classList.remove('horizontal');
    } else {
      this.newsElement.nativeElement.classList.add('horizontal');
      this.newsElement.nativeElement.classList.remove('vertical');
    }
  }
}
